import * as React from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import { AppHashHistory } from '../../web/constants/hash-history';
import { EventsErrorBoundary } from '../components/EventsErrorBoundary';
import { EventsLandingPage } from '../containers/EventsLandingPage';
import { EventsNotFound } from '../components/EventsNotFound';

/**
 * Router for standalone events landing page application.
 *
 * This router is isolated from the main application and loaded at /events.html#/
 * Routes are scoped to this application only.
 *
 * Route pattern note: /:shortCode/landing uses a dynamic parameter, but this is safe because:
 * - ShortCodes are system-generated random alphanumeric strings (e.g., "c42cQI74Ls")
 * - This router is not merged with main app routes
 * - The /landing suffix prevents conflicts with other potential routes
 */
export const EventsRouter: React.FC = () => {
	return (
		<EventsErrorBoundary>
			<Router history={AppHashHistory}>
				<Switch>
					<Route path='/:shortCode/landing' component={EventsLandingPage} />
					<Route path='*' component={EventsNotFound} />
				</Switch>
			</Router>
		</EventsErrorBoundary>
	);
};
